/* eslint-disable @typescript-eslint/no-explicit-any */
// Import Types
import type { SchemaDependency } from 'types';

export default class UIComparisonObject {
    applicationColumnId: any;
    colorUI: any;
    columnId: any;
    comparison: any;
    displayName: any;
    elementType: any;
    errorMessageKey: any;
    filterId: any;
    hashKey: any;
    isAggregated: any;
    isKPI: any;
    maxValue: any;
    minValue: any;
    schemaId: any;
    schemaName: any;
    columnType: any;
    source: any;
    uiType: any;
    validation: any;
    viewType: any;
    /** Data tables the parent filter depends on. */
    schemaDeps: SchemaDependency[] = [];

    constructor(
        comparison = null,
        displayName = null,
        viewType = null,
        elementType = null,
        colorUI = null,
        source = null,
        validation = null,
        minValue = null,
        maxValue = null,
        columnId = null,
        filterId = null,
        hashKey = null,
        applicationColumnId = null,
        schemaId = null,
        schemaName = null,
        columnType = null,
        isAggregated = null,
        isKPI = null,
        errorMessageKey = null,
        uiType = null,
    ) {
        this.comparison = comparison;
        this.displayName = displayName;
        this.viewType = viewType;
        this.elementType = elementType;
        this.colorUI = colorUI;
        this.uiType = uiType;
        this.source = source;
        this.validation = validation;
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.columnId = columnId;
        this.filterId = filterId;
        this.hashKey = hashKey;
        this.applicationColumnId = applicationColumnId;
        this.schemaId = schemaId;
        this.schemaName = schemaName;
        this.columnType = columnType;
        this.isAggregated = isAggregated;
        this.isKPI = isKPI;
        this.errorMessageKey = errorMessageKey;
    }
}
